(() => {
  const root = () => (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');

function updateTotal(form) {
  const output = form.querySelector('[data-neo-total]');
  if (!output) return;

  const controls = [...form.querySelectorAll('[data-neo-variant]')];

  const prices = controls.map(control => Number(
    control.selectedOptions?.[0]?.dataset.price ?? control.dataset.price
  ));

  const complete = controls.length > 1 && controls.every((control, index) =>
    control.value &&
    !control.selectedOptions?.[0]?.disabled &&
    Number.isFinite(prices[index]) &&
    prices[index] >= 0
  );

  let money;

  try {
    money = new Intl.NumberFormat(document.documentElement.lang || 'it', {
      style: 'currency',
      currency: form.dataset.currency ||
        window.Shopify?.currency?.active ||
        'EUR'
    });
  } catch {
    return;
  }

  const discounted = prices.map(price =>
    price - Math.round(price * 0.05)
  );

  const renderPrice = (element, original, reduced) => {
    const oldPrice = document.createElement('s');
    const newPrice = document.createElement('span');

    oldPrice.textContent = money.format(original / 100);
    newPrice.textContent = money.format(reduced / 100);

    element.replaceChildren(oldPrice, newPrice);
  };

  controls.forEach((control, index) => {
    const item = control.closest('.neo-bundle-set__item');
    if (!item) return;

    let preview = item.querySelector('[data-neo-price-preview]');

    if (!preview) {
      preview = document.createElement('p');
      preview.dataset.neoPricePreview = '';
      preview.className = 'neo-bundle-set__price-preview';

      control.insertAdjacentElement('afterend', preview);
    }

    preview.hidden = !complete;

    if (complete) {
      renderPrice(preview, prices[index], discounted[index]);
    }
  });

  output.replaceChildren();

  if (!complete) return;

  renderPrice(
    output,
    prices.reduce((sum, price) => sum + price, 0),
    discounted.reduce((sum, price) => sum + price, 0)
  );

  output.prepend(document.createTextNode('Totale · '));
}

function renderCart(sections, trigger) {
  const html = sections?.['cart-drawer'];

  if (!html) {
    throw new Error(
      'Il set è stato aggiunto. Apri il carrello dall’icona in alto.'
    );
  }

  const parsed = new DOMParser().parseFromString(html, 'text/html');
  const drawer = document.querySelector('sht-cart-drwr');
  const incoming = parsed.querySelector(
    '#cartDrawer .js-cart-drawer-wrapper'
  );
  const current = drawer?.querySelector('.js-cart-drawer-wrapper');

  if (!incoming || !current ||
      typeof drawer.openDrawer !== 'function') {
    throw new Error(
      'Il set è stato aggiunto. Apri il carrello dall’icona in alto.'
    );
  }

  const closeButton = current.querySelector('.js-drawer-btn-close');

  current.innerHTML = incoming.innerHTML;
  current.classList.toggle(
    'is-empty',
    incoming.classList.contains('is-empty')
  );

  const replacementClose = current.querySelector('.js-drawer-btn-close');

  if (closeButton && replacementClose) {
    replacementClose.replaceWith(closeButton);
  }

  drawer.drawerWrapperElement = current;
  drawer.closeBtnElement = current.querySelector('.js-drawer-btn-close');
  drawer.drawerOverlayElement = drawer.querySelector('.js-drawer-overlay');

  const header = sections?.['header-cart-status'];

  if (header) {
    const updated = new DOMParser()
      .parseFromString(header, 'text/html')
      .querySelector('#headerCartStatus');

    const existing = document.querySelector('#headerCartStatus');

    if (updated && existing) {
      existing.innerHTML = updated.innerHTML;
    }
  }

  drawer.openDrawer(trigger);
}

  document.addEventListener('change', event => {
    const form = event.target.closest('form[data-neo-bundle]');
    if (form) updateTotal(form);
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('form[data-neo-add]');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const selects = [...form.querySelectorAll('[data-neo-variant]')];
    const invalid = selects.find(select => !select.value || select.selectedOptions?.[0]?.disabled);
    if (invalid) { invalid.focus(); return; }

    const button = form.querySelector('button[type="submit"]');
    const status = form.querySelector('[data-neo-status]');
    form.dataset.busy = 'true';
    if (button) button.disabled = true;
    if (status) status.textContent = 'Aggiunta in corso…';

    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({
          items: selects.map(select => ({id: Number(select.value), quantity: 1})),
          sections: 'cart-drawer,header-cart-status',
          sections_url: window.location.pathname
        })
      });
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || 'Non è stato possibile aggiungere il prodotto.');
      let sections = data.sections;
      if (!sections?.['cart-drawer']) {
        const fresh = await fetch(root() + '?sections=cart-drawer,header-cart-status');
        if (fresh.ok) sections = await fresh.json();
      }
      renderCart(sections, button);
      if (status) status.textContent = 'Aggiunto al carrello';
    } catch (error) {
      if (status) status.textContent = error.message || 'Riprova tra poco.';
    } finally {
      form.dataset.busy = 'false';
      if (button) button.disabled = false;
    }
  }, true);
})();
